<template>
    <el-container class="adminLayout">
        <el-container class="adminLayoutEmptyMain">
            <el-main class="appBody">
                <router-view :key="$route.fullPath">
                </router-view>
            </el-main>   
        </el-container>
    </el-container>
</template>

<style>
.adminLayoutEmptyMain{
    height: 100% !important;
}
</style>